import React,{useRef, useLayoutEffect, useState} from 'react';

import HaederDesktop from "../assets/images/header-d.png";
import HaederMobile from "../assets/images/header-m.png";
import HaederDesktopSticky from "../assets/images/header-sticky-d.png";
import HaederMobileSticky from "../assets/images/header-sticky-m.png";


import Logo from "../assets/images/logo40.png";
import LogoInner from "../assets/images/logo.png";

export default function Header(props){


    console.log(props);
    const header = useRef(null);
    const [isVisible, setIsVisible] = useState(true);

    function handleScrollChange(){
        if(header?.current){
            const doc = document.documentElement;
            const top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);

            console.log(top < header.current.offsetHeight);

            if(top >= header.current.offsetHeight){
                setIsVisible(false);
            } else {
                setIsVisible(true);
            }
        }
    }

    useLayoutEffect(()=>{
      window.addEventListener('scroll', handleScrollChange);
      handleScrollChange();
    },[])

    return(
        <>
            <header ref={header} className={"app-header" + (props?.inner ? " app-header__inner" : '')}>
                <>
                    <div className={"app-header_image-wrapper"}>
                        <a className={"link-to-ice"} href={"http://www.ice.co.il"}></a>
                        <a className={"link-to-project"} href={"/40under40_2020"}></a>
                        <img src={HaederDesktop} alt="40under40" className={"header-desktop"}/>
                        <img src={HaederMobile} alt="40under40" className={"header-mobile"}/>
                    </div>
                    <h1>
                        לאחר חודשים של עבודה ומתוך מאות מועמדים, נבחרו 40 הכוכבים של ice לשנת 2020.<br/>
                        הפרויקט, בחסות בנק הפועלים ו-HOT, כולל 40 צעירים מעולמות התקשורת, העסקים, הממשל וכן מתחומי
                        פרסום, שיווק ויחסי ציבור. הנבחרים של ice הם אלו שרשמו הישגים משמעותיים ואף כבשו פסגות, או שבדרך
                        לעשות זאת.<br/>
                        הנה 40 הנבחרים לשנת 2020.
                    </h1>
                </>

            </header>
            {!isVisible
              ?
            <header className="app-header app-header_sticky">
                <div className={"app-header_image-wrapper"}>
                    <a className={"link-to-ice"} href={"http://www.ice.co.il"}></a>
                    <a className={"link-to-project"} href={"/40under40_2020"}></a>
                    <img src={HaederDesktopSticky} alt="40under40" className={"header-desktop-sticky"}/>
                    <img src={HaederMobileSticky} alt="40under40" className={"header-mobile-sticky"}/>
                </div>
            </header>
            :
            ''}
        </>
    )
}

